import React, { useEffect, useState } from "react";
import { object, func } from "prop-types";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import { ProfileCard } from "./ProfileCard";
import { EditProfile } from "./EditProfile";
import { EndDateText } from "./EndDateText";
import LinkProfile from "./LinkProfile";
import UpdatePassword from "./UpdatePassword";
import { get } from "lodash";

import "./profile-page.m.css";

export const ProfilePageWithAccesstype = ({
  initAccessType,
  member,
  getSubscriptionForUser,
  cancelSubscription,
  isATGlobal,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [subscriptions, setSubscriptions] = useState(null);
  const [isCancelled, setIsCancelled] = useState(false);

  useEffect(() => {
    initAccessType(() => {
      getSubscriptionForUser()
        .then((res) => {
          setSubscriptions(res?.subscriptions);
        })
        .catch((err) => console.error("Error occurred inside profile page --->", err));
    });
  }, [global.AccessType, member, isATGlobal]);

  const cancelSubscriptionHandler = (subscriptionId) => {
    cancelSubscription(subscriptionId)
      .then((res) => {
        initAccessType(() => {
          getSubscriptionForUser()
            .then((res) => {
              setSubscriptions(res?.subscriptions);
              setIsCancelled(true);
            })
            .catch((err) => console.error("Error occurred inside profile page --->", err));
        });
      })
      .catch((err) => console.error("Error from cancelSubscription is --->", err));
  };

  const getActiveSubscriptions = (subscriptions = []) => {
    const activeSubscriptions = Array.isArray(subscriptions)
      ? subscriptions
        .filter(plan => plan.subscription_type === "standard" || plan.subscription_type === "group_access")
        .filter(plan => plan.status === "active")
      : [];

    return (
      <div>
        {isCancelled && (
          <p style={{ fontWeight: 'bold', border: '2px solid #a20d39', padding: '10px' }}>
            Tilauksesi peruutus onnistui! Voi kestää hetken, ennen kuin peruutus näkyy profiilitiedoissasi.
          </p>
        )}
        <div styleName="active-plan-label">
          Tilaustiedot:
        </div>
        {activeSubscriptions?.length > 0 ? (
          activeSubscriptions.map((subscription, id) => (
            <div styleName="custom-profile-box" key={id}>
              <div styleName="custom-profile-item">
                <h3>Tilaustaso</h3>
                <p>{subscription.plan_name}</p>
              </div>

              <div styleName="custom-profile-item">
                <h3>Tila</h3>
                <p className="active">Aktiivinen</p>
              </div>

              <div styleName="custom-profile-item">
                <h3>Hinta</h3>
                <p>{subscription.plan_amount_currency}&nbsp;{subscription.plan_amount_cents / 100}</p>
              </div>

              {subscription.cancelled ? (
                <>
                  <div styleName="custom-profile-item">
                    <h3>Tilaus päättyy:</h3>
                    <p>
                      {new Date(subscription.end_timestamp).toLocaleDateString("fi-FI", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                  </div>

                  <div styleName="custom-profile-item">
                    <h3>Tilaus peruttu:</h3>
                    <p>
                      {new Date(subscription.cancelled_at).toLocaleDateString("fi-FI", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                  </div>
                </>
              ) : (
                <div styleName="custom-profile-item">
                  <h3>{subscription.recurring ? "Uusimispäivämäärä" : "Päättyy klo"}</h3>
                  <p>
                    {new Date(subscription.end_timestamp).toLocaleDateString("fi-FI", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                </div>
              )}

              {!subscription.cancelled && !isCancelled && (
                <div styleName="custom-profile-item">
                  <button
                    styleName="custom-edit-btn cancel-edit-btn"
                    onClick={() => cancelSubscriptionHandler(subscription.id)}
                  >
                    Peruuta tilaus
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <div styleName="custom-profile-box">
            <p>Aktiivisia tilauksia ei löytynyt.</p>
            <p>Teitkö juuri tilauksen? Voi kestää hetki ennen kuin uusi tilaus näkyy aktiivisena profiilin tiedoissa.</p>
          </div>
        )}
      </div>
    );
  };

  {/* we will enable this feature later. */}
  {/*const getExpiredSubscriptions = (subscriptions = []) => {
    const expiredPlans = Array.isArray(subscriptions)
      ? subscriptions
          .filter(
            (plan) => plan.status === "expired" && (plan.subscription_type === "standard" || plan.subscription_type === "group_access")
          )
          .slice(0, 1)
      : [];

    return (
      <div styleName="expired-subscriptions-block">
        <div styleName="active-plan-label">{expiredPlans.length === 1 ? "Pääntynyt Sopimus" : "Pääntyneet Suunnitelmat"}:</div>
        {expiredPlans.length > 0 ? (
          expiredPlans.map((subscription, id) => (
            <div styleName="custom-profile-box" key={id}>
              <div styleName="custom-profile-item">
                <h3>Tilaustaso</h3>
                <p>{subscription.plan_name}</p>
              </div>

              <div styleName="custom-profile-item">
                <h3>Tilaus päättyi klo</h3>
                <p>{new Date(subscription.end_timestamp).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}</p>
              </div>
            </div>
          ))
        ) : (
          <div styleName="custom-profile-box">Vanhentuneita tilauksia ei löytynyt.</div>
        )}
      </div>
    );
  };*/}

  const InvoicesList = ({ subscriptions }) => {
    const handleDownloadInvoice = async (subscriptionId, invoiceId) => {
        try {
            if (!global.AccessType) {
                console.log('Accesstype is not loaded!');
                return;
            }

            const invoiceResponse = await global.AccessType.downloadInvoice(subscriptionId, invoiceId);
            const bodyBlob = get(invoiceResponse, ['_bodyBlob']);
            if (!bodyBlob) throw new Error('Error fetching invoice');
            const blob = new Blob([bodyBlob], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `Kuitti_${invoiceId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error downloading invoice:", error);
        }
    };

    const activeInvoices = subscriptions
      .filter(subscription => subscription.status === "active")
      .flatMap(subscription =>
        subscription.invoices.map(invoice => ({
          ...invoice,
          subscriptionId: subscription.id,
          subscriptionPlanName: subscription.plan_name
        }))
    );

    return (
      <>
        <div styleName="active-plan-label">Laskuhistoria:</div>
        <div styleName="custom-profile-box custom-invoice-list">
          {activeInvoices.length == 0 ? (
            <p>Laskuja ei ole saatavilla.</p>
          ) : (
            <>
            {activeInvoices.map(invoice => (
              <div styleName="custom-invoice-item"  key={invoice.id}>
                <span>
                  {new Date(invoice.created_at).toLocaleDateString("fi-FI", {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                  })},
                </span>
                <p>{invoice.subscriptionPlanName} - {invoice.amount_currency} {invoice.amount_cents / 100}</p>
                <a href="#" onClick={() => handleDownloadInvoice(invoice.subscriptionId, invoice.id)}>Lataa kuitti</a>
              </div>
            ))}
            </>
          )}
        </div>
      </>
    );
  };

  if (!member) {
    return <div styleName="profile-wrapper">
      <div styleName="profile-page">
        <div styleName="not-logged-in">Olet kirjautunut ulos, siirry takaisin etusivulle <a href="/" styleName="tasta-link">tästä</a>.</div>
      </div>
    </div>
    ;
  }

  return (
    <div styleName="profile-wrapper">
      <div styleName="profile-page">
        <div styleName="profile-page-title"><h2>Oma profiili</h2></div>

        <div styleName="custom-profile-header">
          {isEditing ? (
            <EditProfile member={member} setIsEditing={setIsEditing} isEditing={isEditing} />
          ) : (
            <div>
              {/*<div styleName="avatar-image-wrapper">
                {member["avatar-url"] ? (
                  <img src={member["avatar-url"]} alt="avatar" height="100px" width="100px" styleName="avatar-image" />
                ) : (
                  <SvgIconHandler type="user" styleName="avatar-image" width="100" height="100"/>
                )}
                </div>*/}
              <h3 styleName="member-name">{member.name}</h3>
              <p>{member.email}</p>
              <a href="#" styleName="custom-edit-btn" onClick={() => setIsEditing(true)}>Muokkaa profiilia</a>
              {/*<a href="#" styleName="custom-edit-btn" onClick={() => setShowLinkModal(true)}>Linkitä puhelinnumero</a>*/}
              <a href="#" styleName="custom-edit-btn" onClick={() => setShowPasswordModal(true)}>Päivitä salasana</a>
              {showLinkModal && <LinkProfile onClose={() => setShowLinkModal(false)} member={member} />}
              {showPasswordModal && <UpdatePassword onClose={() => setShowPasswordModal(false)} member={member} />}
            </div>
          )}
        </div>

        <div styleName="custom-content-wrapper">
          <div styleName="left-sidebar-content">
            {subscriptions === null ? (
                <p style={{ marginTop: "10px" }}>Etsimme tilauksiasi, Odota.</p>
              ) : (
              <>
                {getActiveSubscriptions(subscriptions)}
                {/*{getExpiredSubscriptions(subscriptions)}*/}
              </>
            )}
          </div>

          {subscriptions?.length > 0 && (
            <div styleName="right-sidebar-content">
              <InvoicesList subscriptions={subscriptions} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ProfilePageWithAccesstype.propTypes = {
  initAccessType: func,
  member: object,
  getSubscriptionForUser: func,
  cancelSubscription: func,
  isATGlobal: func,
};
